module.exports = __webpack_public_path__ + "img/Storage=MNG-Off.5da956b2.svg";